import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { policyAPI } from "../../api/ebam/policy/policy-api";
import { socketSetup } from "../../library/socket-io/socket-setup";
import { usePolicyDataState } from "../policy/use-policy-data-state";

interface SocketPayload {
    policyId?: number;
    proposalId?: number;
    payloadId?: number;
}
// my api for effective date is from proposalAPI
export const usePolicySocket = () => {
    const dispatch = useDispatch();
    const { policyId: currentPolicyId } = usePolicyDataState()

    const invalidate = useCallback(
    (payload?: SocketPayload | null) => {

        dispatch(policyAPI.util.invalidateTags([
            { type: "Policy", id: "LIST" },
            { type: "PolicyTAT", id: "LIST" },
        ]));

        const updatedPolicyId = payload?.policyId ?? payload?.proposalId ?? payload?.payloadId;
        if ( currentPolicyId == null || updatedPolicyId == null || Number(updatedPolicyId) !== Number(currentPolicyId) ) {
            return;
        }

        dispatch(policyAPI.util.invalidateTags([
            { type: "Policy", id: currentPolicyId },
            { type: "PolicyTAT", id: currentPolicyId },
        ]));
    },
    [dispatch, currentPolicyId]
);

    useEffect(() => {

        const events = [
            "updateEffectiveDate",
            "saveContractSigningAddress",
            "resetContractSigningAddress",

            "saveContractTat",
            "resetContractTat",
            
            "saveContractDocCode",
            "clearContractDocCode",
            "saveContractGclipOutstanding",
            "saveContractGclipPrincipal",
            "saveContractGpa",

            "issuePolicyContract",
            "updateEbamStatus",

            "approvePolicyContract",

            "declinePolicyContract",
        ];

        events.forEach((event) => {
            socketSetup.on(event, invalidate);
        });


        return () => {
            events.forEach((event) => {
                socketSetup.off(event, invalidate);
            });
        };
    }, [invalidate]);
};